import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'

const SplitwiseJoin = () => {
    const navigate = useNavigate()
    const { token } = useParams()
    const [failed, setFailed] = useState(false)

    useEffect(() => {
        if (!token) {
            setFailed(true)
            return
        }
        service
            .post(endpoints.splitwise.join.replace('{token}', token), {})
            .then(() => {
                navigate('/profile', { replace: true, state: { section: 'groups' } })
            })
            .catch(() => setFailed(true))
    }, [token, navigate])

    if (failed) {
        return (
            <section className='allSearchArea commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <p className='fare-extra-hint'>This invite link is invalid or has expired.</p>
                    <button type='button' className='commonBtn' onClick={() => navigate('/profile', { state: { section: 'groups' } })}>Go to Groups</button>
                </div>
            </section>
        )
    }

    return (
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <p className='fare-extra-hint'>Joining group...</p>
            </div>
        </section>
    )
}

export default SplitwiseJoin
